module.exports = __webpack_public_path__ + "static/assets/6e2207424607719839367cba92f92717.png";